import motion from "@/lib/lazy-motion-tags";
import { CheckCircle2 } from "lucide-react";

const AboutSection = () => {
  const achievements = [
    "أكثر من 500 مشروع منجز",
    "5 سنوات خبرة في تصنيع أبواب WPC",
    "نسبة رضا العملاء 100%",
    "مطابقة معايير الجودة العالمية",
  ];

  return (
    <section className="py-24 bg-gradient-to-br from-background to-muted/50 overflow-x-hidden">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Content */}
          <motion.div
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-6">
              رواد في صناعة أبواب <span className="text-gradient">WPC</span> في السعودية
            </h2>
            <p className="text-lg text-muted-foreground mb-8 leading-relaxed">
              نحن نعيد تعريف صناعة الأبواب من خلال تقنية الخشب البلاستيكي المركب (WPC) ونجمع بين الجودة والتنافسية. نقدم منتجات عصرية بتصميم عالمي لعملائنا في قطاع البناء والتشطيبات بأسعار تنافسية.
            </p>

            {/* Achievements */}
            <div className="space-y-4">
              <h3 className="text-2xl font-bold mb-6">أرقام نفتخر بها:</h3>
              {achievements.map((achievement, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: -30 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.6, delay: index * 0.1 }}
                  viewport={{ once: true }}
                  className="flex items-center gap-4"
                >
                  <div className="flex-shrink-0 w-8 h-8 rounded-full bg-gradient-primary flex items-center justify-center">
                    <CheckCircle2 className="h-5 w-5 text-accent" />
                  </div>
                  <p className="text-lg font-medium">{achievement}</p>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* Image/Stats Grid */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="grid grid-cols-1 sm:grid-cols-2 gap-6 overflow-hidden"
          >
            {[
              { number: "500+", label: "مشروع منجز", bg: "bg-gradient-to-br from-primary to-secondary" },
              { number: "5", label: "سنوات خبرة", bg: "bg-gradient-to-br from-secondary to-copper" },
              { number: "100%", label: "رضا العملاء", bg: "bg-gradient-to-br from-copper to-gold" },
              { number: "25+", label: "سنة عمر افتراضي", bg: "bg-gradient-to-br from-gold to-primary" },
            ].map((stat, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className={`${stat.bg} rounded-2xl p-8 text-center shadow-elegant hover-lift`}
              >
                <div className="text-5xl font-bold text-accent mb-3">{stat.number}</div>
                <div className="text-sm font-medium text-accent/90">{stat.label}</div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
